import { connect } from 'react-redux';
import NewRouteModal from '../../components/Dispatch/NewRouteModal';
import { saveNewRoute } from '../../actions/dispatch_actions';

function mapStateToProps(state) {
  return {
    savingNewRoute: state.dispatch.savingNewRoute,
    saveNewRouteSuccess: state.dispatch.saveNewRouteSuccess,
    saveNewRouteError: state.dispatch.saveNewRouteError,
  };
}

export default connect(mapStateToProps, { saveNewRoute })(NewRouteModal);



// WEBPACK FOOTER //
// ./master/jsx/containers/Dispatch/NewRouteModal.jsx